import { getNotificationClient, countNotification } from './services';
import { NotificationDataSlice } from './reducer';
import { RETCODE_SUCCESS } from '@configs/contants';

export const {
  setListNotification,
  setCountNotification,
  setNotificationError,
  setNotificationLoading,
} = NotificationDataSlice.actions;

export const onSetCountNotification = (count) => async (dispatch) => {
  try {
    setNotificationLoading(true);
    dispatch(setCountNotification(userInfo));
  } catch (err) {
    dispatch(setNotificationError(err));
    throw new Error(err);
  } finally {
    dispatch(setNotificationLoading(true));
  }
};

export const onGetNotificationClient = (payload) => async (dispatch) => {
  try {
    setNotificationLoading(true);
    const res = await getNotificationClient(payload);
    if (res.retCode !== RETCODE_SUCCESS) {
      return;
    }
    if (!!res.data) {
      dispatch(setListNotification(res.data));
    }
  } catch (err) {
    dispatch(setNotificationError(err));
    throw new Error(err);
  } finally {
    dispatch(setNotificationLoading(true));
  }
};

export const onCountNotification = (eventId) => async (dispatch) => {
  try {
    setNotificationLoading(true);
    const res = await countNotification(eventId);
    if (res.retCode !== RETCODE_SUCCESS) {
      return;
    }

    if (!!res.data) {
      dispatch(setCountNotification(res.data));
    }
  } catch (err) {
    dispatch(setNotificationError(err));
    throw new Error(err);
  } finally {
    dispatch(setNotificationLoading(true));
  }
};

export default NotificationDataSlice.reducer;
